export interface ISubscriptionPayment {
  quantity: number;
  price: string;
}
